import { ApiService } from "./api.service";
import moment from "moment";
import { PrimeIcons } from "@primevue/core/api";

export default class LedgerService extends ApiService {
  namespace = "account";
  DOMAIN = 56;
  template = "defaultTemplate";
  icon = "BoxWithStar";
  favicon = "BoxWithStar";
  columns = [
    {
      header: "Date",
      icon: "Calendar",
      field: "date",
      template: (data) => {
        return moment.unix(data.date).format("MM/DD/YYYY").format("MM/DD/YYYY");
      },
      width: "6",
    },
    {
      header: this.t("account"),
      icon: "Property",
      field: "number",
    },
    {
      header: this.t("type"),
      icon: "Notebook",
      field: "type",
    },
    {
      header: this.t("amount"),
      icon: "Money",
      field: "amount",
    },
  ];
  listMenu = [
    {
      key: "create",
      label: this.t("openThisEntity", { entity: "Transaction" }),
      icon: PrimeIcons.BOOK,
    },
    {
      key: "listing",
      label: this.t("viewEntity", { entity: "Transaction" }),
      icon: PrimeIcons.LIST,
    },
  ];
  gemMenuItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: "Employee" }),
      service: 17,
      icon: PrimeIcons.LIST,
    },
    {
      key: "create",
      label: "Vendor Create",
      service: 18,
      icon: PrimeIcons.LIST,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: "Ladger" }),
      service: -1,
      icon: PrimeIcons.LIST,
    },
  ];

  constructor() {
    super("journal-entries");
  }
}
